import React, { useMemo, useState } from "react";
import { useGetTransactionsQuery } from "state/api";
import {
  PageContainer,
  DataTable,
  TableToolbar,
  StatusChip,
  normalizeList,
  formatCurrency,
  formatDate,
} from "components/shared";

const Transactions = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0); // 0-based for TablePagination
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const { data, isFetching } = useGetTransactionsQuery({
    page: page + 1,
    pageSize: rowsPerPage,
    search,
  });

  const { rows, total } = useMemo(
    () => normalizeList(data, { page: page + 1, pageSize: rowsPerPage }),
    [data, page, rowsPerPage]
  );

  const columns = useMemo(
    () => [
      {
        field: "invoiceNumber",
        headerName: "Invoice",
        render: (t) =>
          t.invoiceNumber || t.orderNumber || t._id?.slice(-6).toUpperCase(),
      },
      {
        field: "createdAt",
        headerName: "Date",
        render: (t) => formatDate(t.createdAt),
      },
      {
        field: "customer",
        headerName: "Customer",
        render: (t) => t.customer?.name || "—",
      },
      {
        field: "total",
        headerName: "Amount",
        align: "right",
        render: (t) => formatCurrency(t.total),
      },
      {
        field: "paymentMethod",
        headerName: "Payment",
        render: (t) => (t.paymentMethod || "—").toUpperCase(),
      },
      {
        field: "paymentStatus",
        headerName: "Status",
        render: (t) => <StatusChip status={t.paymentStatus || t.status} />,
      },
    ],
    []
  );

  return (
    <PageContainer title="Transactions" subtitle="Entire list of transactions">
      <TableToolbar
        search={search}
        onSearchChange={(v) => {
          setSearch(v);
          setPage(0);
        }}
        searchPlaceholder="Search by invoice or order number…"
      />
      <DataTable
        columns={columns}
        rows={rows}
        loading={isFetching}
        emptyText="No transactions found"
        page={page}
        rowsPerPage={rowsPerPage}
        total={total}
        onPageChange={setPage}
        onRowsPerPageChange={(n) => {
          setRowsPerPage(n);
          setPage(0);
        }}
      />
    </PageContainer>
  );
};

export default Transactions;
